export default __webpack_public_path__ + "static/Grayic-42c15fab1985ee949c865b5a8143e47d.ttf";